import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69fbc3b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filelist" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  style: {"width":"100%"},
  controls: "",
  autoplay: "",
  muted: "",
  ref: "videoPlayer"
}
const _hoisted_4 = ["src"]

import { ref } from 'vue'
import { EyeOutlined, FilePdfOutlined, WarningTwoTone } from '@ant-design/icons-vue'
import axios from 'axios'

type MediaItem = {
  id: number
  name: string
  file_name: string
  url: string
  type: string
  date: string
  important: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Filelist',
  props: {
  media: {
    type: Array,
    required: true
  }
},
  setup(__props) {



const showPreviewModal = ref(false)
// eslint-disable-next-line camelcase
const file = ref<MediaItem|null>(null)

// eslint-disable-next-line camelcase
function togglePreviewModal (fileToPreview:MediaItem|null = null) : void {
  if (!showPreviewModal.value && fileToPreview) {
    if (fileToPreview.type === 'application/pdf') {
      downloadFile(fileToPreview)
    } else {
      file.value = fileToPreview
      showPreviewModal.value = true
    }
  } else {
    file.value = null
    showPreviewModal.value = false
  }
}

function downloadFile (mediaItem:MediaItem) : void {
  axios.get(process.env.VUE_APP_API_URL + '/building/documents/' + mediaItem.id + '/download', { responseType: 'arraybuffer' })
    .then(response => {
      const blob = new Blob([response.data], { type: mediaItem.type })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = mediaItem.name
      link.click()
    })
}

const imageMimeTypes = ['image/jpeg', 'image/png']
const videoMimeTypes = ['video/mp4']

function isImage (type: string): boolean {
  return imageMimeTypes.includes(type)
}

function isVideo (type: string): boolean {
  return videoMimeTypes.includes(type)
}

function getVideoUrl (file: MediaItem): string {
  if (file instanceof File) return URL.createObjectURL(file)
  else return file.url
}


return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_list, {
      "item-layout": "horizontal",
      "data-source": __props.media,
      size: "small"
    }, {
      renderItem: _withCtx(({ item }) => [
        _createVNode(_component_a_list_item, null, {
          actions: _withCtx(() => [
            _createElementVNode("span", null, [
              _createVNode(_component_a_button, {
                onClick: ($event: any) => (togglePreviewModal(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(EyeOutlined))
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_list_item_meta, {
              class: "clickable",
              description: item.date,
              style: {"font-weight":"500","line-break":"anywhere"}
            }, {
              avatar: _withCtx(() => [
                (item.type === 'application/pdf')
                  ? (_openBlock(), _createBlock(_component_a_avatar, {
                      key: 0,
                      class: "clickable",
                      shape: "square",
                      style: _normalizeStyle([{ backgroundColor: '#f38929' }, {"font-size":"18px"}]),
                      onClick: ($event: any) => (togglePreviewModal(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FilePdfOutlined))
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_a_avatar, {
                      key: 1,
                      class: "clickable",
                      shape: "square",
                      src: item.url,
                      onClick: ($event: any) => (togglePreviewModal(item))
                    }, null, 8, ["src", "onClick"]))
              ]),
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.file_name) + " ", 1),
                _createVNode(_component_a_tooltip, { title: "Belangrijk ongelezen document!" }, {
                  default: _withCtx(() => [
                    (item.important)
                      ? (_openBlock(), _createBlock(_unref(WarningTwoTone), {
                          key: 0,
                          "two-tone-color": "#f38929",
                          style: {"margin-left":"8px"}
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["description"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data-source"]),
    (file.value)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          title: file.value.file_name,
          width: 600,
          footer: null,
          visible: showPreviewModal.value,
          "body-style": { padding: 0 },
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (togglePreviewModal()))
        }, {
          default: _withCtx(() => [
            (isImage(file.value.type))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: file.value.url,
                  style: {"width":"100%"}
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            (isVideo(file.value.type))
              ? (_openBlock(), _createElementBlock("video", _hoisted_3, [
                  _createElementVNode("source", {
                    src: getVideoUrl(file.value),
                    type: "video/mp4"
                  }, null, 8, _hoisted_4)
                ], 512))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})